import React from 'react';
import styles from './index.module.scss'; // 👆 your shimmer.scss

const PayDayShimmer = () => {
  return (
    <div className={styles.shimmerWrapper}>
      {/* Header */}
      <div className={`${styles.shimmer} ${styles.shimmerText}`}></div>

      {/* Banner */}
      <div className={`${styles.shimmer} ${styles.shimmerBanner}`}></div>

      {/* Categories */}
      <div className={styles.section}>
        <div className={`${styles.shimmer} ${styles.shimmerText}`}></div>
        <div
          style={{
            display: 'flex',
            gap: '24px',
            overflow: 'scroll',
            marginTop: '10px',
          }}
        >
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className={`${styles.shimmer} ${styles.shimmerCategory}`}
            ></div>
          ))}
        </div>
      </div>

      {/* Exclusive */}
      <div className={styles.section}>
        <div className={`${styles.shimmer} ${styles.shimmerText}`}></div>
        <div
          style={{
            display: 'flex',
            gap: '16px',
            overflow: 'scroll',
            marginTop: '10px',
          }}
        >
          {[1, 2].map((i) => (
            <div
              key={i}
              className={`${styles.shimmer} ${styles.shimmerExclusive}`}
            ></div>
          ))}
        </div>
      </div>

      {/* FAQ */}
      <div>
        <div className={`${styles.shimmer} ${styles.shimmerText}`}></div>
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className={`${styles.shimmer} ${styles.shimmerFAQ}`}
            style={{ marginTop: '10px' }}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default PayDayShimmer;
